module.exports = __webpack_public_path__ + "img/homerton_hs_b1.62b6472e.jpg";